var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 134,
    viewBox: "0 0 111 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44506 123.792L88.9358 132.687L108.996 10.8952L21.5053 2L1.44506 123.792Z",
    fill: "#A05C2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18329 118.357L84.1768 126.071L102.255 16.3306L26.2616 8.61652L8.18329 118.357Z",
    fill: "#632A1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53355 116.891L83.3457 124.384L100.905 17.7953L27.0926 10.3026L9.53355 116.891Z",
    fill: "#7D3723"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7704 112.49L44.7907 115.214L52.1794 70.3803L25.1591 67.6565L17.7704 112.49Z",
    fill: "#A96B50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5111 115.214L17.7704 112.523L20.3732 109.639L42.7816 111.894L44.5111 115.214Z",
    fill: "#8B4427"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1794 70.3471L25.4387 67.6565L27.1858 70.977L49.5562 73.2279L52.1794 70.3471Z",
    fill: "#B7896B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4082 109.943L43.0625 112.221L49.5387 72.9262L26.8844 70.6484L20.4082 109.943Z",
    fill: "#A46437"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6253 115.896L74.644 118.619L82.0327 73.7861L55.0139 71.0624L47.6253 115.896Z",
    fill: "#A96B50"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3643 118.62L47.6252 115.929L50.2281 113.045L72.6364 115.3L74.3643 118.62Z",
    fill: "#8B4427"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0327 73.7529L55.2935 71.0624L57.0406 74.3829L79.4111 76.6338L82.0327 73.7529Z",
    fill: "#B7896B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2646 113.349L72.9189 115.627L79.3951 76.3324L56.7408 74.0546L50.2646 113.349Z",
    fill: "#A46437"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0625 112.221L26.8844 70.6484L49.5387 72.9262L43.0625 112.221Z",
    fill: "#AF754C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9189 115.627L56.7408 74.0546L79.3951 76.3324L72.9189 115.627Z",
    fill: "#AF754C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.665 61.1157L53.6853 63.8395L61.0739 19.0061L34.0536 16.2823L26.665 61.1157Z",
    fill: "#A96B50"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4055 63.8405L26.6648 61.1498L29.2677 58.2657L51.676 60.5204L53.4055 63.8405Z",
    fill: "#8B4427"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0739 18.9729L34.3332 16.2823L36.0801 19.604L58.4505 21.8549L61.0739 18.9729Z",
    fill: "#B7896B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3026 58.5693L51.9569 60.8471L58.4331 21.5527L35.7788 19.2748L29.3026 58.5693Z",
    fill: "#A46437"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5198 64.5216L83.5386 67.2453L90.9272 22.4119L63.9085 19.6883L56.5198 64.5216Z",
    fill: "#A96B50"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2587 67.2463L56.5196 64.5558L59.1225 61.6717L81.5308 63.9264L83.2587 67.2463Z",
    fill: "#8B4427"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9272 22.3787L64.1881 19.6883L65.935 23.01L88.3054 25.2609L90.9272 22.3787Z",
    fill: "#B7896B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1591 61.9755L81.8134 64.2533L88.2896 24.9588L65.6353 22.681L59.1591 61.9755Z",
    fill: "#924B2A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9569 60.8471L35.7788 19.2748L58.4331 21.5527L51.9569 60.8471Z",
    fill: "#AF754C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1591 61.9755L81.8134 64.2533L88.2896 24.9588L65.6353 22.681L59.1591 61.9755Z",
    fill: "#A46437"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8134 64.2533L65.6353 22.681L88.2896 24.9588L81.8134 64.2533Z",
    fill: "#AF754C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0367 78.6543L84.0732 78.1528C83.6699 78.1121 83.3858 77.8204 83.4384 77.5012L84.9301 68.4492C84.9827 68.13 85.3521 67.9044 85.7553 67.9451L90.7188 68.4466C91.1221 68.4874 91.4062 68.779 91.3536 69.0982L89.8619 78.1503C89.8093 78.4695 89.4399 78.6951 89.0367 78.6543Z",
    fill: "#9B6E2F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.2371 77.8177L84.6865 77.3579C84.3167 77.3206 84.0561 77.0531 84.1044 76.7604L85.4719 68.4615C85.5201 68.1688 85.8589 67.9619 86.2287 67.9993L90.7793 68.4591C91.1491 68.4965 91.4097 68.7639 91.3615 69.0566L89.9939 77.3555C89.9457 77.6482 89.6069 77.8551 89.2371 77.8177Z",
    fill: "#BB933F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4423 71.6721C90.2649 72.757 89.0242 73.5222 87.6704 73.3829C86.3149 73.2434 85.3615 72.2524 85.539 71.1675C85.7162 70.0838 86.9569 69.3186 88.3123 69.4581C89.6661 69.5975 90.6195 70.5885 90.4423 71.6721Z",
    fill: "#A77E35"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8875 71.6149C89.7503 72.4536 88.7896 73.0451 87.7433 72.9374C86.6954 72.8295 85.9583 72.0634 86.0955 71.2246C86.2325 70.3871 87.1917 69.7955 88.2395 69.9034C89.2858 70.0111 90.0245 70.7774 89.8875 71.6149Z",
    fill: "#BB933F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1607 72.634C89.9932 72.1171 90.1499 71.1591 89.5079 70.4917C88.8644 69.8229 87.6675 69.6998 86.8309 70.2124L89.1607 72.634Z",
    fill: "#C9AB64"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1867 74.62C88.2399 74.297 87.9518 73.9998 87.5422 73.9584C87.1326 73.917 86.756 74.147 86.7028 74.47C86.6608 74.7249 86.8279 74.9598 87.0997 75.0706L86.4251 76.2338L87.8835 76.3812L87.6097 75.1222C87.9069 75.0689 88.1447 74.8748 88.1867 74.62Z",
    fill: "#1E2721"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.1f727dce.svg";
export { ForwardRef as ReactComponent };